import { reviewSchema } from '@/utils/validation/reviewSchema';
import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver, ValidationMode } from 'react-hook-form';

export const formConfig = {
  resolver: yupResolver(reviewSchema) as Resolver<IReviewForm>,
  mode: 'all' as keyof ValidationMode,
  defaultValues: {
    review: '',
    rating: 0
  },
};
